module.exports = __webpack_public_path__ + "static/media/shopee_logo_en.2ff680e4.jpg";